// @ts-nocheck
import authAPI from './api';
import TYPES from './types';
import swManager from 'serviceWorker/swManager';

export const login = (dispatch) => async (email, password, successCB, errorCB) => {
    const onError = (error) => {
        if (errorCB && typeof errorCB === 'function') {
            errorCB(error);
        } else {
            throw new Error(`Error logging in: ${JSON.stringify(error)}`);
        }
    };

    const onSuccess = (data) => {
        dispatch({
            type: TYPES.LOGIN,
            payload: {
                email: data.user,
                idToken: data.idToken,
                refreshToken: data.refreshToken,
                expiresAt: data.expiresAt,
            },
        });

        if (successCB && typeof successCB === 'function') {
            successCB(data);
        }
    };

    try {
        const res = await authAPI.login({ data: { email: email, password: password } });

        // I'd expect a 200 response here, but the API gives us 201
        if (res?.status === 200 || res?.status === 201) {
            onSuccess(res?.data?.data);
        }
    } catch (error) {
        onError(error);
    }
};

export const logout = (dispatch) => async (errContext) => {
    await swManager.destroy();

    // We don't don't tell the API about this at the moment
    dispatch({ type: TYPES.LOGOUT });
};

export const refreshToken = (dispatch) => async (authContext, errContext) => {
    // Prevent spamming refresh token requests if the one we have isn't expired yet
    if (Date.now() > authContext.state.expiresAt) {
        console.log('idToken expired, requesting a new one');
    }
    else {
        return authContext.state.idToken;
    }

    try {
        const refreshToken = authContext.state.refreshToken;
        const res = await authAPI.refreshToken({ data: { refreshToken: refreshToken } });

        if (res?.status === 200 || res?.status === 201) {
            const data = res?.data?.data;

            dispatch({
                type: TYPES.REFRESH_TOKEN,
                payload: {
                    idToken: data.idToken,
                    refreshToken: data.refreshToken,
                    expiresAt: data.expiresAt,
                },
            });

            return data.idToken;
        }
    } catch (error) {
        if (errContext) {
            errContext.DISPATCH({ type: 'API_ERROR', payload: error });
        } else {
            throw new Error(`Error refreshing token: ${JSON.stringify(error)}`);
        }
    }
};

export const resetPassword = (dispatch) => async (email, successCB, errorCB) => {
    const onError = (error) => {
        if (errorCB && typeof errorCB === 'function') {
            errorCB(error, email);
        } else {
            throw new Error(`Error resetting password: ${JSON.stringify(error)}`);
        }
    };

    const onSuccess = () => {
        dispatch({ type: TYPES.RESET_PASSWORD });

        if (successCB && typeof successCB === 'function') {
            successCB(email);
        }
    };

    try {
        const res = await authAPI.resetPassword( { data: { email: email } } );

        if (res?.status === 200 || res?.status === 201) {
            onSuccess();
        }
    } catch (error) {
        onError(error);
    }
};

export const completeLogin = (dispatch) => async () => {
    dispatch({ type: TYPES.COMPLETE_LOGIN });
};
